import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", gap: 2 }}>
      <Typography variant="h4">Page not found</Typography>
      <Typography variant="body2" color="text.secondary">
        The page you are looking for doesn’t exist or has moved.
      </Typography>
      <Button variant="contained" onClick={() => navigate("/drive")}>Go to My Drive</Button>
    </Box>
  );
};

export default NotFound;
